import api from './axios';

export const adminApi = {
  // ── Gigs ──
  listAllGigs: (params) => api.get('/admin/gigs', { params }).then((r) => r.data),
  resolveDispute: (id, resolution, notes) =>
    api.patch(`/admin/gigs/${id}/resolve-dispute`, { resolution, notes }).then((r) => r.data),

  // ── User management ──
  listUsers: (params) => api.get('/admin/users', { params }).then((r) => r.data),
  getUserDetail: (userId) => api.get(`/admin/users/${userId}`).then((r) => r.data),

  // ── Verifications ──
  listVerifications: (params) =>
    api.get('/admin/verifications', { params }).then((r) => r.data),

  getVerificationDetail: (userId) =>
    api.get(`/admin/verifications/${userId}`).then((r) => r.data),

  reviewDocument: (userId, type, { status, rejectionReason } = {}) =>
    api
      .patch(`/admin/verifications/${userId}/documents/${type}`, { status, rejectionReason })
      .then((r) => r.data),

  setVerificationStatus: (userId, status) =>
    api.patch(`/admin/verifications/${userId}/status`, { status }).then((r) => r.data),

  // ── Additional verification request ──
  requestAdditional: (userId, message) =>
    api
      .post(`/admin/verifications/${userId}/request-additional`, { message })
      .then((r) => r.data),

  clearAdditionalRequest: (userId) =>
    api
      .delete(`/admin/verifications/${userId}/request-additional`)
      .then((r) => r.data),

  // ── User edit ──
  updateUser: (userId, payload) =>
    api.patch(`/admin/users/${userId}`, payload).then((r) => r.data),

  // ── Bookings ──
  listBookings: (params) => api.get('/admin/bookings', { params }).then((r) => r.data),
  getBookingDetail: (id) => api.get(`/admin/bookings/${id}`).then((r) => r.data),
  endBooking: (id) => api.patch(`/admin/bookings/${id}/end`).then((r) => r.data),
  resolveCancellation: (id, decision) =>
    api.patch(`/admin/bookings/${id}/resolve-cancellation`, { decision }).then((r) => r.data),

  // ── Payments (refunds + payouts) ──
  paymentQueues: (params) => api.get('/admin/payments', { params }).then((r) => r.data),
  refundBooking: (id, payload) => api.post(`/admin/payments/${id}/refund`, payload).then((r) => r.data),
  releasePayout: (id) => api.post(`/admin/payments/${id}/release-payout`).then((r) => r.data),

  // ── Invoices & per-job financial ledger ──
  listFinancialLedger: (params) => api.get('/admin/invoices', { params }).then((r) => r.data),
  getFinancialLedgerDetail: (bookingId) => api.get(`/admin/invoices/${bookingId}`).then((r) => r.data),
  reconcileFinancialLedger: (bookingIds) =>
    api.post('/admin/invoices/reconcile', { bookingIds }).then((r) => r.data),
};

export default adminApi;
